import { Divider, Grid } from '@mui/material'
import { MaterialReactTable, MRT_ColumnDef, MRT_TableOptions } from 'material-react-table'
import { FunctionComponent } from 'react'

import MontoMonedaTexto from '../../../../base/components/PopoverMonto/MontoMonedaTexto'
import { MuiTableAdvancedOptionsProps } from '../../../../utils/muiTable/muiTableAdvancedOptionsProps'
import { RecetaArticuloProp, RecetaProp } from '../../interfaces'

interface OwnProps {
  receta: RecetaProp
}

const InsumosListado: FunctionComponent<OwnProps> = ({ receta }) => {
  const columns: MRT_ColumnDef<RecetaArticuloProp>[] = [
    {
      header: 'Producto',
      size: 300,
      accessorFn(row) {
        return (
          <>
            {row.articulo?.codigoArticulo}-{' '}
            <strong>{row.articulo?.nombreArticulo}</strong>
          </>
        )
      },
    },
    {
      header: 'Cantidad',
      size: 200,
      accessorFn(row) {
        return (
          <>
            <MontoMonedaTexto
              id={`cantidad`}
              monto={row.cantidad ?? 0}
              sigla={row.articuloUnidadMedida.nombreUnidadMedida}
            />
          </>
        )
      },
    },
  ]

  return (
    <Grid
      container
      spacing={2}
      size={{
        xs:
          receta.productosAdicionales && receta.productosAdicionales.length > 0 ? 6 : 12,
        lg: 12,
      }}
    >
      <Grid
        size={{
          xs: 12,
          sm: 12,
          lg:
            receta.productosAdicionales && receta.productosAdicionales.length > 0
              ? 6
              : 12,
        }}
      >
        <Divider textAlign={'left'} sx={{ mb: 0, color: 'warning.main' }}>
          <strong>INSUMOS</strong>
        </Divider>
        <MaterialReactTable
          {...(MuiTableAdvancedOptionsProps as MRT_TableOptions<RecetaArticuloProp>)}
          columns={columns}
          data={receta.insumos}
          enableRowActions={false}
          enablePagination={false}
          enableSorting={false}
          enableColumnFilters={false}
          enableFullScreenToggle={false}
          enableHiding={false}
          enableColumnOrdering={false}
          enableColumnActions={false}
          muiTableBodyRowProps={{ sx: { '& td': { padding: '4px' } } }}
          muiTopToolbarProps={{ sx: { display: 'none' } }}
          manualPagination
          muiBottomToolbarProps={{ sx: { display: 'none' } }}
        />
      </Grid>
      {receta.productosAdicionales && receta.productosAdicionales.length > 0 && (
        <Grid
          size={{
            xs: 12,
            sm: 12,
            lg:
              receta.productosAdicionales && receta.productosAdicionales.length > 0
                ? 6
                : 12,
          }}
        >
          <Divider textAlign={'left'} sx={{ mb: 0, color: 'primary.main' }}>
            <strong>PRODUCTOS ADICIONALES</strong>
          </Divider>
          <MaterialReactTable
            {...(MuiTableAdvancedOptionsProps as MRT_TableOptions<RecetaArticuloProp>)}
            columns={columns}
            data={receta.productosAdicionales}
            enableRowActions={false}
            enablePagination={false}
            enableSorting={false}
            enableColumnFilters={false}
            enableFullScreenToggle={false}
            enableHiding={false}
            enableColumnActions={false}
            muiTopToolbarProps={{ sx: { display: 'none' } }}
            muiTableBodyRowProps={{ sx: { '& td': { padding: '4px' } } }}
            manualPagination
            muiBottomToolbarProps={{ sx: { display: 'none' } }}
          />
        </Grid>
      )}
    </Grid>
  )
}

export default InsumosListado
